import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from "@/components/ui/button";
import { ChevronLeft } from "lucide-react";

const Terms = () => {
  return (
    <div className="min-h-screen bg-sonas-bg text-sonas-text p-6 lg:p-20">
      <div className="max-w-3xl mx-auto space-y-12">
        <Link to="/">
          <Button variant="ghost" className="gap-2 text-sonas-dim hover:text-sonas-text">
            <ChevronLeft size={16} /> Back to Grid
          </Button>
        </Link>
        
        <header className="space-y-4">
          <h1 className="text-5xl font-syne font-bold">Terms of Service</h1>
          <p className="text-sonas-muted">Last updated: March 14, 2026</p>
        </header>

        <div className="prose prose-invert prose-sonas max-w-none">
          <h2 className="text-2xl font-bold">1. The Service</h2>
          <p>Sonas provides an AI-augmented workspace for Roblox development. By creating an account, you gain access to our proprietary inference pipeline, project management tools, and the Studio synchronization bridge.</p>

          <h2 className="text-2xl font-bold mt-8">2. Account Responsibility</h2>
          <p>You are responsible for safeguarding your login credentials. Any activity occurring under your Architect Node (account) is your legal responsibility. If you suspect unauthorized access, you must notify us immediately via our support channels.</p>

          <h2 className="text-2xl font-bold mt-8">3. AI Content & Roblox Compliance</h2>
          <p>Sonas generates Luau code based on user prompts. Users must verify all generated code before applying it to production environments. We are not liable for actions taken by Roblox Corporation (including account bans or experience removals) resulting from code generated by our system. All code must adhere to the Roblox Terms of Use.</p>

          <h2 className="text-2xl font-bold mt-8">4. Payments and Subscriptions</h2>
          <p>Transactions are processed via SellApp using PayPal. Credit packs provide immediate token balances. Architect Pro subscriptions provide recurring benefits. Due to the digital and consumable nature of AI compute credits, all sales are final and non-refundable once any portion of the credits has been used.</p>

          <h2 className="text-2xl font-bold mt-8">5. Termination of Service</h2>
          <p>We reserve the right to suspend or terminate access for any account that violates our Acceptable Use Policy. In the event of termination, any remaining credit balance is forfeited.</p>
        </div>
      </div>
    </div>
  );
};

export default Terms;